const SPRITE_HAPPENING_ART: Partial<Record<string, string>> = {
  interrupt: "interrupt",
  sendback: "sendback",
  "service-outage": "service-outage",
  "req-change": "req-change",
};

const GENERATED_HAPPENING_ART: Partial<Record<string, string>> = {
  "unwanted-staff": "/happenings/unwanted-staff.png",
  "pending-tasks": "/happenings/pending-tasks.png",
  "draw-restriction": "/happenings/draw-restriction.png",
  "retained-tasks": "/happenings/retained-tasks.png",
  "weekend-work": "/happenings/weekend-work.png",
  "incident-response": "/happenings/incident-response.png",
  "update-eve": "/happenings/update-eve.png",
  "night-release": "/happenings/night-release.png",
  "rework-ticket": "/happenings/rework-ticket.png",
  rebuild: "/happenings/rebuild.png",
  scrap: "/happenings/scrap.png",
  "expectation-gap": "/happenings/expectation-gap.png",
  "client-review": "/happenings/client-review.png",
  "scope-creep": "/happenings/scope-creep.png",
  "prod-incident": "/happenings/prod-incident.png",
  "system-outage": "/happenings/system-outage.png",
  "critical-system-outage": "/happenings/critical-system-outage.png",
};

export function spriteHappeningArt(loadId: string): string | undefined {
  return SPRITE_HAPPENING_ART[loadId];
}

export function generatedHappeningArt(loadId: string): string | undefined {
  return GENERATED_HAPPENING_ART[loadId];
}

export function hasHappeningArt(loadId: string): boolean {
  return loadId in SPRITE_HAPPENING_ART || loadId in GENERATED_HAPPENING_ART;
}
